import React, { useState, useEffect } from "react";
import { backend, API_URL } from "../../../config";
import { Button, Modal, CircularProgress, Container } from "@mui/material";
import { makeStyles } from "@mui/styles";

import UploadFile from "../components/UploadFile";
import ReceiptPreview from "../components/ReceiptPreview";

import readXlsxFile from "read-excel-file";
import writeXlsxFile from "write-excel-file";
import RDNavBar from "../components/RDNavBar";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600)]: {
      width: 900,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(5),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const receiptHeaderOld = [
  [
    "2020-12-04T05:43:19.000Z",
    null,
    null,
    null,
    null,
    "Branch 43 Los Angeles,CA",
    null,
    null,
    null,
  ],
  ["Click here to print", null, null, null, null, null, null, null, null],
  ["Download Excel version", null, null, null, null, null, null, null, null],
  [
    null,
    null,
    null,
    null,
    null,
    "Import Receipt",
    "View All Quotes",
    null,
    "View A Quote",
  ],
  [
    null,
    "Branch: 43 - 5333 West Jefferson Blvd, Los Angeles, CA 90016-3713",
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ],
  [
    null,
    "Phone: 323-964-1220  Fax: 323-964-1230",
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ],
  ["Invoice", null, 158798, null, null, null, null, null, null],
  [
    "Customer",
    null,
    4323553,
    null,
    "Order Date",
    null,
    "2020-12-04T00:00:00.000Z",
    null,
    null,
  ],
  [
    "Business Name",
    null,
    "FRIENDLY FOODS INC",
    null,
    "Order Amount",
    null,
    8413.81,
    null,
    null,
  ],
  [
    "Address",
    null,
    "8410,SALT LAKE AVE",
    null,
    "Amount Paid",
    null,
    0,
    null,
    null,
  ],
  [
    null,
    null,
    "CUDAHY, CA 902015818",
    null,
    "Balance Due",
    null,
    8413.81,
    null,
    null,
  ],
  [
    "Phone",
    null,
    3236535900,
    null,
    "Convert From Quote",
    null,
    140372,
    null,
    null,
  ],
  [null, null, null, null, null, null, null, null, null],
  [null, null, null, null, null, null, null, null, null],
];

const columnsWidthOld = [
  { width: 80 },
  { width: 65.14 },
  { width: 20.86 },
  { width: 28.57 },
  { width: 19.29 },
  { width: 24.86 },
  { width: 13.14 },
  { width: 7.43 },
  { width: 11.29 },
  { width: 20.86 },
];

export const ReceiptUpload = (props) => {
  const classes = useStyles();
  const cDate = new Date();
  const cDateString = new Date(
    cDate.getTime() - cDate.getTimezoneOffset() * 60000
  ).toISOString();

  let yDate = new Date();
  yDate.setDate(yDate.getDate() - 1);

  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  // const [responseModal, setResponseModal] = useState(false);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);

  const [receiptData, setReceiptData] = useState([]);
  const [receiptDataImported, setReceiptDataImported] = useState(false);
  const [receiptDataMapped, setReceiptDataMapped] = useState([]);
  const [receiptHeadersIndex, setReceiptHeadersIndex] = useState(0);
  const [receiptName, setReceiptName] = useState("receipt" + cDateString);
  const [receiptId, setReceiptId] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [warehousesSelected, setWarehousesSelected] = useState("");
  const [reviewReceipt, setReviewReceipt] = useState(false);

  const handleChangeReceiptData = (data, file) => {
    let dataImported = [];

    switch (file.type) {
      case "text/csv":
        data
          .map((item) => item.data)
          .forEach((item) => {
            if (item.length > 1) {
              dataImported.push(item);
            }
          });
        setReceiptData(dataImported);
        setReceiptDataImported(true);

        break;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        readXlsxFile(file).then((data) => {
          data.forEach((item) => {
            if (item.length > 1) {
              dataImported.push(item);
            }
          });
          setReceiptData(dataImported);
          setReceiptDataImported(true);
        });

        break;
      default:
        setErrorInfo({
          error: true,
          message:
            "The imported file it's not compatible. Please use a .csv or .xlsx file.",
        });
    }

    if (!errorInfo.error) {
      const receiptFilename =
        file.name.substring(0, file.name.length - 4) || "receipt";
      setReceiptName(`${receiptFilename} (${cDateString})`);
    }
  };

  const handleChangeReceiptDataMapped = (data) => {
    setReceiptDataMapped(data);
  };

  const handleChangeReceiptName = (e) => {
    const { value } = e.target;
    setReceiptName(value);
  };

  const handleChangeWarehouses = (e) => {
    const { value } = e.target;
    setWarehousesSelected(value);
  };

  const handleClickOldExport = async () => {
    const importedDateTop = receiptData[0][0];

    const importedInvoiceIndex = receiptData.findIndex((item) =>
      ["invoice"].includes(String(item[0]).toLowerCase())
    );

    const importedInvoice =
      importedInvoiceIndex === -1
        ? receiptData[10][2]
        : receiptData[importedInvoiceIndex][2];

    const importedDateOrderIndex = receiptData.findIndex((item) =>
      ["order date"].includes(String(item[4]).toLowerCase())
    );

    const importedDateOrder =
      importedDateOrderIndex === -1
        ? receiptData[11][6]
        : receiptData[importedDateOrderIndex][6];

    const receiptDataStripped = receiptData.filter(
      (item, index) => index >= receiptHeadersIndex
    );

    const receiptDataMerged = [...receiptHeaderOld, ...receiptDataStripped];

    const receiptDataExport = receiptDataMerged.map((row, rowIndex) =>
      row.map((cell, cellIndex) => {
        let cellObj = { value: cell };

        if (rowIndex === 0 && cellIndex === 0) {
          cellObj.format = "dd/mm/yyyy HH:MM";
          cellObj.type = Date;
          cellObj.value = importedDateTop || cDateString;
        }

        if (rowIndex === 6 && cellIndex === 2) {
          cellObj.value = importedInvoice || "Not Found";
        }

        if (rowIndex === 7 && cellIndex === 6) {
          cellObj.format = "dd/mm/yyyy";
          cellObj.type = Date;
          cellObj.value = importedDateOrder || cDateString;
        }

        return cellObj;
      })
    );

    await writeXlsxFile(receiptDataExport, {
      columns: columnsWidthOld,
      fileName: `${receiptName}.xlsx`,
    });
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          {`Are you sure you want to ${receiptId === null ? "save" : "update"}
          the receipt `}
          <b>{receiptName}</b>
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving receipt information <br />
              This may take some time relative to the number of items
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the receipt information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveRequest()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Receipt information have been successfully saved
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an issue while saving some rows from the receipt
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
            </>
          ) : (
            <></>
          )}
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const resolveRequest = () => {
    setFinishedFlag(false);
    toggleConfirmModal();

    if (!errorInfo.error) {
      props.history.push("/receiptDifference");
    }
  };

  const sendRequest = async () => {
    setLoadingFlag(true);

    if (receiptId === null) {
      const receiptDataTotal = receiptDataMapped.reduce(
        (prev, item) => prev + item.total,
        0
      );
      const receiptObj = {
        description: receiptName,
        total: +receiptDataTotal.toFixed(2),
        warehouse: 2,
        pricing_type: "s",
      };

      await backend
        .post(`${API_URL}receipts/`, receiptObj)
        .then(({ data }) => {
          const receiptId = data.id;
          setReceiptId(receiptId);
          saveReceiptData(receiptId);
        })
        .catch((error) => {
          console.log(error);
          setErrorInfo({
            error: true,
            message: JSON.stringify(error.response.data),
          });
        });
    } else {
      saveReceiptData(receiptId);
    }
  };

  const saveReceiptData = async (receiptId) => {
    const receiptDataArray = receiptDataMapped.map((item) => ({
      ...item,
      receipt: receiptId,
    }));

    await backend
      .post(`${API_URL}receiptlines/`, receiptDataArray)
      .then(({ data }) => {
        setLoadingFlag(false);
        setFinishedFlag(true);

        if (data?.message_detail?.length) {
          setErrorInfo({ error: true, message: data.message });
          setReceiptData(data.message_detail);
        } else {
          setErrorInfo({ error: false, message: "" });
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
        deleteReceipt(receiptId);
      });
  };

  const deleteReceipt = async (receiptId) => {
    await backend
      .delete(`${API_URL}receipts/`, receiptId)
      .then(() => {})
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
      });
  };

  useEffect(() => {
    const getWarehouses = () => {
      setWarehouses([
        {
          id: 2,
          name: "Restaurant Depot",
          csv_header_mapping: {
            UPC: "product",
            Qty: "quantity",
            "C/U": "unit_type",
            "Ext. Value": "total",
          },
          unit_type_mapping: {},
        },
      ]);
    };

    getWarehouses();
  }, []);

  useEffect(() => {
    if (receiptDataImported && receiptId === null) {
      if (!receiptData.length) {
        setErrorInfo({
          error: true,
          message:
            "The imported file couldn't be processed (it didn't generate any data to be imported).",
        });
      } else {
        const headersIndex = receiptData.findIndex((item) =>
          ["line", "upc"].includes(String(item[0]).toLowerCase())
        );

        setReceiptHeadersIndex(headersIndex);

        if (headersIndex === -1) {
          setErrorInfo({
            error: true,
            message:
              "The imported file couldn't be processed (couldn't find the headers from the imported data).",
          });
        }
      }
    }
  }, [receiptData, receiptDataImported, receiptId]);

  return (
    <Container>
      <Modal open={confirmModal} onClose={toggleConfirmModal}>
        {confirmModalContent}
      </Modal>
      <RDNavBar {...props} />
      {receiptData.length && reviewReceipt ? (
        <ReceiptPreview
          {...props}
          receiptData={receiptData}
          receiptName={receiptName}
          warehouses={warehouses}
          warehousesSelected={warehousesSelected}
          receiptId={receiptId}
          handleChangeReceiptDataMapped={handleChangeReceiptDataMapped}
          handleChangeReceiptName={handleChangeReceiptName}
          handleChangeWarehouses={handleChangeWarehouses}
          toggleConfirmModal={toggleConfirmModal}
        />
      ) : (
        <UploadFile
          {...props}
          errorInfo={errorInfo}
          receiptData={receiptData}
          receiptHeadersIndex={receiptHeadersIndex}
          setErrorInfo={setErrorInfo}
          setReviewReceipt={setReviewReceipt}
          handleChangeReceiptData={handleChangeReceiptData}
          handleClickOldExport={handleClickOldExport}
        />
      )}
    </Container>
  );
};

export default ReceiptUpload;
